import { Injectable } from '@angular/core';

import { GameType } from '@bpos/v1/sports-promo';

import { BetslipType } from '../../../../../core/betslip-type';
import { CriteriaType, IRewardToken } from '../../../reward-tokens.model';
import { TokenPicksValidity, TokenValidationInput, TokensCriteriaValidatorBase, picksValidity } from '../criteria-validator-base.service';

@Injectable()
export class GameTypeValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.GameType;
    isValid(token: IRewardToken, state: TokenValidationInput): TokenPicksValidity {
        const picks = state.selectedPicks;

        if (!token.filter?.gameType) {
            return picksValidity(true, picks);
        }

        let validPicks = [];
        switch (token.filter.gameType) {
            case GameType.Mixed: {
                validPicks = picks;
                break;
            }
            case GameType.InPlay: {
                validPicks = picks.filter((pick) => pick.isLive);
                break;
            }
            case GameType.PreMatch: {
                validPicks = picks.filter((pick) => !pick.isLive);
                break;
            }
        }

        if (state.selectedType === BetslipType.Single || state.selectedType === BetslipType.BetBuilder) {
            return picksValidity(validPicks.length > 0, validPicks);
        }

        return picksValidity(validPicks.length > 0 && validPicks.length === picks.length, validPicks);
    }
}
